import { Injectable } from '@angular/core';
import {Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild} from '@angular/router';

import { Logger } from '../logger/logger.service';
import { CredentialsService } from './credentials.service';
import {AuthenticationService} from './authentication.service';
import {Observable} from 'rxjs';

const log = new Logger('AuthenticationGuard');

@Injectable({
  providedIn: 'root'
})
export class AuthenticationGuard implements CanActivateChild {
  constructor(
    private router: Router,
    private credentialsService: CredentialsService,
    private authenticationService: AuthenticationService) {}

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean>|boolean {
    if (this.credentialsService.isAuthenticated()) {
      this.authenticationService.redirectUrl = state.url;
      return true;
    } else if (this.credentialsService.isRefreshNotExpired()) {
      return new Observable<boolean>((observer) => {
        this.authenticationService.fetchNewAccessToken(this.credentialsService.credentials.username).subscribe(res => {
          observer.next(true);
          observer.complete();
        });
      });
    } else {
      log.debug('Not authenticated, redirecting and adding redirect url...');
      this.authenticationService.logout().subscribe(() => this.router.navigate(['/login'], {queryParams: {returnUrl: state.url}}));
      return false;
    }
  }
}
